import * as React from "react";
import { useEffect, useState } from "react";

import { API_Registry } from "../../../src/apidefs";
import { api } from "../api";
import { Page } from "../DesignSystem/formatting/TwoColumnView";
import { UserCard } from "./UserCard";

export const RegistryPage = (): JSX.Element => {
  const [registry, setRegistry] = useState<API_Registry>({ users: [] });

  useEffect(() => {
    const fetchRegistry = async () => {
      setRegistry(await api.get("/api/registry"));
    };

    fetchRegistry();
  }, []);

  return (
    <Page>
      <div className="rounded-2xl border border-slate-200 bg-white/90 px-6 py-5 shadow-sm backdrop-blur-sm dark:border-slate-700 dark:bg-slate-800 dark:shadow-none">
        <h1 className="mb-6 text-2xl font-bold text-slate-800 dark:text-white">
          User Registry
        </h1>
        <div className="space-y-2">
          {registry.users.map(
            ({
              user,
              main_entries,
              side_entries,
            }: API_Registry["users"][number]) => (
              <UserCard
                key={user.id}
                main_entries={main_entries}
                side_entries={side_entries}
                user={user}
                showProfile={true}
              />
            )
          )}
        </div>
      </div>
    </Page>
  );
};
